
// my secrets
// export const supabaseUrl = "https://ozkvgkcksferjqxialjz.supabase.co";
// export const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96a3Zna2Nrc2ZlcmpxeGlhbGp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1MjkwNTgsImV4cCI6MjA2MjEwNTA1OH0.UDkTmEk-Z7uYmBJ-7LsHH2eQqYyAPsWeFc4n_oQB71Y";


// original secrets
export const supabaseUrl = "https://lghztpzmoswstjafword.supabase.co";
export const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnaHp0cHptb3N3c3RqYWZ3b3JkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI3NTgzODAsImV4cCI6MjA1ODMzNDM4MH0.WvFFs4NSX5zzprmXiqefmXNvMQFRiKOzFKrJQV6RMN8";

